import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PrivateService } from 'app/core/services/private.service';
import { retry } from 'rxjs/operators';
import { timer } from 'rxjs';

@Component({
  selector: 'dialog-workdays-requests',
  templateUrl: './dialog-workdays-requests.component.html',
  styleUrls: ['./dialog-workdays-requests.component.scss']
})
export class DialogWorkdaysRequestsComponent implements OnInit {
  userInput: string = '';
  isLoading: boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogWorkdaysRequestsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private privateService: PrivateService,) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  approveLeave(id: number) {
    this.isLoading = true;
    this.privateService.workdaysRequestApproval(id, 'Approved').pipe(
      retry({ count: 3, delay: () => timer(2000) })
    ).subscribe({
      next: () => {
        this.isLoading = false;
        this.dialogRef.close(true);
      },
      error: () => {
        this.isLoading = false;
        this.dialogRef.close();
      }
    });
  }

  declineLeave(id: number, reason: string) {
    this.isLoading = true;
    this.privateService.workdaysRequestApproval(id, 'Reject', reason).pipe(
      retry({ count: 3, delay: () => timer(2000) })
    ).subscribe({
      next: () => {
        this.isLoading = false;
        this.dialogRef.close(true);
      },
      error: () => {
        this.isLoading = false;
        this.dialogRef.close();
      }
    });
  }
}
